export default __webpack_public_path__ + "static/media/access-industry-member.e2114445.svg";